import React, { memo } from 'react';
import TourLogo from '../../../TourLogo/TourLogo';
import TourButtons from '../TourButtons/TourButtons';
import { useTranslation } from 'react-i18next';

const TourLogoWrapper = memo(
  ({
    tourId,
    tourName,
    currentTour,
    currentTour: { buttons = [], styles },
    tier,
    checkLogoURL,
    publicTour,
    aid,
  }) => {
    const { t } = useTranslation();
    const tourButtons = [...buttons];
    if (tier === 'trial' || tier === 'starter') {
      tourButtons.unshift({
        id: 'trial-gallery-btn',
        newTab: true,
        title: 'CONCEPT3D GALLERY',
        type: 'standard',
        url: 'https://map.concept3d.com/?id=1164#!ct/0,47130',
      });
    }
    return (
      <div
        aria-label={t('publicTour.ada.tourLogo.links')}
        tabIndex={0}
        className="logo-btns-container"
        id="logo-btns-container"
        role="banner"
      >
        <TourLogo
          currentTour={currentTour}
          tier={tier}
          checkLogoURL={checkLogoURL}
          publicTour={publicTour}
          aid={aid}
        />
        <TourButtons
          tourId={tourId}
          aid={aid}
          tourName={tourName}
          buttons={tourButtons}
          isMobile={window.innerWidth < 1025}
          {...styles}
        />
      </div>
    );
  }
);

export default TourLogoWrapper;
